import React from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';

import { Image, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroProductImage = (props: Props) => {
  const { alt, position = 'top-left', url } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const outerContainerStyles = [styles.outerContainer, positionStyles[position]];
  const imageStyles = match([styles.imageXS, styles.imageSM]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={outerContainerStyles}>
      <View style={styles.container}>
        <Image source={url} contentFit="cover" style={imageStyles} alt={alt} />
      </View>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE_XS = 80;
const IMAGE_SIZE_SM = 120;

const CORNER_OFFSET = theme.spacing['4'];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    position: 'absolute',
  },
  container: {
    aspectRatio: 1,
    backgroundColor: theme.colors.CREAM,
    borderColor: theme.colors.BROWN,
    borderRadius: theme.radius['3xLarge'],
    borderWidth: 2,
    flex: 1,
    overflow: 'hidden',
  },
  imageXS: {
    width: IMAGE_SIZE_XS,
    height: IMAGE_SIZE_XS,
  },
  imageSM: {
    width: IMAGE_SIZE_SM,
    height: IMAGE_SIZE_SM,
  },
});

const positionStyles = StyleSheet.create<Record<Position, ViewStyle>>({
  'top-left': {
    top: CORNER_OFFSET,
    left: CORNER_OFFSET,
  },
  'top-right': {
    top: CORNER_OFFSET,
    right: CORNER_OFFSET,
  },
  'bottom-left': {
    bottom: CORNER_OFFSET,
    left: CORNER_OFFSET,
  },
  'bottom-right': {
    bottom: CORNER_OFFSET,
    right: CORNER_OFFSET,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  alt: string;
  url: string;
  position?: Position;
};

type Position = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
